import styled from 'styled-components';
import C from '@assets/themes/colors';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: ${C.WHITE};
  border-radius: 8px;
  width: 820px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  background: ${C.SOFT_GRAY};
  padding: 24px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: bold;
  color: ${C.BLACK};
  margin: 0;
`;

export const ModalBody = styled.div`
  padding: 24px;
  font-size: 16px;
  color: ${C.BLACK};
  line-height: 1.5;
`;

export const ModalText = styled.p`
  margin: 0;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 20px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const ModalButton = styled.button`
  padding: 10px 40px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s, border 0.3s;
  text-transform: uppercase;

  &.cancel {
    background: ${C.WHITE};
    color: ${C.BLACK};
    border: 1px solid ${C.DARK_BLUE};
    &:hover {
      background: ${C.LIGHT_GRAY};
    }
  }

  &.delete {
    background: ${C.DARK_BLUE};
    color: ${C.WHITE};
    &:hover {
      background: ${C.BLUE_HOVER};
      cursor: pointer;
    }
  }
`;